module.exports = __webpack_public_path__ + "img/oneClick.78d8c75a.svg";